import { VListItem } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,{attrs:{"items":_vm.roles,"item-value":"id","label":_vm.$t('pages.roleSelect'),"disabled":_vm.lock},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var index = ref.index;
var on = ref.on;
var attrs = ref.attrs;
return [_c(VListItem,_vm._g(_vm._b({style:({'background-color': _vm.getColor(item)})},'v-list-item',attrs,false),on),[_vm._v("\n\t\t\t"+_vm._s(item.text)+"\n\t\t\t"),(item.id < 5)?_c('span',[_vm._v(" - CADnet")]):_vm._e()])]}}]),model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}
var staticRenderFns = []

export { render, staticRenderFns }